<template>
  <img
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    :loading="isPriority ? 'eager' : 'lazy'"
    :fetchpriority="isPriority ? 'high' : undefined"
    :class="{ 'mini-photo': miniPhoto }"
    @load="checkLoadStatue(true)"
    @error="checkLoadStatue(false)"
  />
  <div
    v-if="miniPhoto"
    class="empty-img"
  >
    <p v-if="isViewNoPhotoText">Нет фото</p>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';

  const props = withDefaults(
    defineProps<{
      src?: string;
      width?: string;
      height?: string;
      alt?: string;
      borderRadius?: string;
      aspectRatio?: string;
      isPriority?: boolean;
    }>(),
    {
      alt: '',
      aspectRatio: undefined,
      borderRadius: undefined,
      height: undefined,
      isPriority: false,
      src: undefined,
      width: '100%',
    },
  );

  const imgIsLoad = ref<boolean>();

  const isViewNoPhotoText = computed(() => {
    return !props.src || imgIsLoad.value === false;
  });

  const miniPhoto = computed(() => {
    return !props.src || !imgIsLoad.value;
  });

  const checkLoadStatue = (value: boolean) => {
    imgIsLoad.value = value;
  };
</script>

<style lang="scss" scoped>
  @use '@experience/design-tokens/typography' as legacy-typography;

  img,
  .empty-img {
    width: v-bind('props.width');
    min-width: v-bind('props.width');
    height: v-bind('props.height');
    min-height: v-bind('props.height');
    aspect-ratio: v-bind('props.aspectRatio');
    object-fit: cover;
    border-radius: v-bind('props.borderRadius');
  }

  .empty-img {
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('@/shared/assets/empty.jpg');
    background-repeat: no-repeat;
    background-size: cover;

    p {
      color: var(--alias-color-text-default);
      opacity: 0.3;

      @include legacy-typography.base-400-300-regular;
    }
  }

  .mini-photo {
    position: absolute;
    z-index: -1;
    width: 0;
    height: 0;
  }
</style>
